export const ajaxProgressThrobber = message => {
  // Build markup without adding extra white space since it affects rendering.
  return'<div class="progress"><div class="indeterminate"></div></div>';
};
